import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Product from "../components/Product";

const ProductPage = (props) => {

	const product = props.data.products;

	return (
		<Layout>
			<Product product={ product } />
		</Layout>
	);
};

// Var $sku corresponds to var declared in gatsby-node.js
export const pageQuery = graphql`
  query ($sku: String) {
    products(sku: {eq: $sku}) {
      sku
      name
      price
      category
      slug
    }
  }
`;

export default ProductPage;
